import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Dialog, Spinner } from '@economic/taco';
import { refreshCurrentLegacyPage } from '@economic/react-app';
import DistributionKeyDialog from './DistributionKeyDialog';
import internalApiClient from '../../../../shared/util/api/internalApiClient';
import useQuery from '../../../../shared/hooks/useQuery';
import { t, useLocalization } from '../../../../shared/components/l10n/l10n';

function CopyDistributionKeyDialog() {
    const location = useLocation();
    const navigate = useNavigate();
    const { id } = location.state || ({} as any);

    const { loading, data: departmentalDistribution } = useQuery(`/setup/departmental-distributions/${id}`);
    const loadingTexts = useLocalization(textIds);

    if (!id) {
        return null;
    }

    if (loadingTexts || loading) {
        return (
            <Dialog open={location.hash === '#copy-distribution-key'} onClose={hide}>
                <Dialog.Content aria-label="">
                    <Spinner />
                </Dialog.Content>
            </Dialog>
        );
    }

    async function handleSubmit(values) {
        const submitUrl = `/setup/departmental-distributions/${values.distributionKeyNumber}`;
        const validationResult = await internalApiClient.post(`${submitUrl}/validate`, values);
        if (validationResult.data && validationResult.data.length > 0) {
            throw new Error(validationResult.data[0]);
        }

        await internalApiClient.post(submitUrl, values);
        window?.top?.refetch('/departments?includeDistributionKeys=true');
        refreshCurrentLegacyPage('content');
        hide();
    }

    function hide() {
        navigate(location.pathname);
    }

    return (
        <DistributionKeyDialog
            allowChangeNumber
            headerText={!loadingTexts && t`FORM_DISTRIBUTIONKEY_CREATEHEADLINE`}
            hide={hide}
            open={location.hash === '#copy-distribution-key'}
            distributionKey={departmentalDistribution}
            onSubmit={handleSubmit}
        />
    );
}

const textIds = ['FORM_DISTRIBUTIONKEY_CREATEHEADLINE'];

export default CopyDistributionKeyDialog;
